import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import OpenCameraComponent from "./OpenCameraComponent";
import { FaWindowClose } from "react-icons/fa";
import { FaCameraRetro } from "react-icons/fa";
import Select from "react-select";
import { State, City } from "country-state-city";
import AadhaarOTPModal from "./AadhaarOTPModal";

function CreateCheckIn() {
  const navigate = useNavigate();
  const [isPreBooked, setIsPreBooked] = useState(true);
  const [bookingDetails, setBookingDetails] = useState({});
  const [building, setBuilding] = useState([]);
  const [floor, setFloor] = useState([]);
  const [floorNumber, setFloorNumber] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [load, setLoad] = useState(false);
  const [buildingId, setBuildingId] = useState("");
  const [bed, setBed] = useState([]);
  const [isCam, setIsCam] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState("");
  const [isCameraLoading, setIsCameraLoading] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(document.createElement("canvas"));
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [aadhaar, setAadhaar] = useState("");
  const [showSendOtpButton, setShowSendOtpButton] = useState(false);
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [sendOTPResponse, setSendOTPResponse] = useState();
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [roomData, setRoomData] = useState({});
  // const []
  console.log("------->", bookingDetails);

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      joiningDate: bookingDetails?.joiningDate,
    },
  });

  useEffect(() => {
    if (bookingDetails) {
      setValue("joiningDate", bookingDetails?.joiningDate?.slice(0, 10));
    }
  }, [bookingDetails]);

  //Fetch all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  useEffect(() => {
    if (roomData.bedRent) {
      setValue("bedRent", roomData.bedRent);
    }
  }, [roomData]);

  console.log("Selected City: ", selectedCity);

  //Fetch cities when a state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  console.log("All States: ", allStates);
  console.log("All Cities: ", allCities);

  //Open the camera...
  const openCamera = () => {
    setIsCameraOpen(true);
    setIsCam(true);
  };

  useEffect(() => {
    const startCamera = async () => {
      if (isCameraOpen && videoRef.current) {
        setIsCameraLoading(true);
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: true,
          });
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          setIsCameraLoading(false);
        } catch (error) {
          console.error("Error accessing the camera:", error);
          setIsCameraLoading(false);
        }
      }
    };
    startCamera();
  }, [isCameraOpen]);

  //Capture photo
  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    if (canvas && video) {
      const context = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Draw the video frame onto the canvas
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Get the data URL of the captured image
      const imageDataUrl = canvas.toDataURL("image/png");

      // Create a File object for React Hook Form
      const blob = dataURLtoBlob(imageDataUrl);
      const file = new File([blob], "captured-photo.png", {
        type: "image/png",
      });

      // Update React Hook Form with the captured photo
      setValue("photo", file, { shouldValidate: true });
      setCapturedImage(imageDataUrl);

      closeCamera();
    }
  };

  //Close the camera
  const closeCamera = () => {
    // setIsCam(false);

    setIsCameraOpen(false);
    const stream = videoRef.current?.srcObject;
    const tracks = stream?.getTracks();
    tracks?.forEach((track) => track.stop());
  };

  const dataURLtoBlob = (dataURL) => {
    const [header, data] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(data);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: mime });
  };

  const getBookingById = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/booking/get_booking_by_id/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("booking--->", response.data);
        setBookingDetails(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Get All Building Data
  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Calling the booking details by Id
  const getFloors = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setFloor(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
    if (id) {
      getBookingById();
    } else {
      setIsPreBooked(false);
    }
  }, []);

  const getConfiguredRoomByBuilding = (floorNumber) => {
    setFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const handleBed = (id) => {
  //   const myData = {
  //     roomId: id,
  //   };

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${process.env.REACT_APP_API_URL}/beds/get-beds-by-room-id`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: myData,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log("----beds array-->", response.data.data);
  //       setBed(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const getRoomById = (id) => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/rooms/get_room_by_id/${id}`,
      maxBodyLength: Infinity,
      headers: {},
    };

    axios.request(config).then((response) => {
      console.log("Response of getRoomById: ", response.data);
      setRoomData(response.data.data);
      setBed(response.data.data.beds);
    });
  };

  const clearCapturedImage = () => {
    setCapturedImage("");
    setIsCam(false);
  };

  //Aadhaar Verification
  //Send OTP
  const handleSendOTPClick = (aadhaar) => {
    const data = {
      aadhaar: aadhaar,
    };
    setLoad(true);
    // let config = {
    //   method: "post",
    //   maxBodyLength: Infinity,
    //   url: `${process.env.REACT_APP_API_URL}/aadhaar/sendOTP`,
    //   headers: {
    //     "x-client-id": "",
    //     "x-client-secret": "",
    //     "Content-Type": "application/json",
    //   },
    //   data: data,
    // };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.CASHFREE_API_URL_TEST}/offline-aadhaar/otp`,
      headers: {
        "x-client-id": `${process.env.CLIENT_ID}`,
        "x-client-secret": `${process.env.SECRET_KEY}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of SendOTP: ", response.data);
        if (response.data.status === "SUCCESS") {
          toast.success("OTP sent successfully");
          setSendOTPResponse(response.data);
          setLoad(false);
          setOpenOTPModal(true);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        toast.error("Failed to send OTP");
        setLoad(false);
      });
  };

  console.log("sendOTPResponse: ", sendOTPResponse);

  const onSubmit = async (data) => {
    // if (isAadhaarVerified) {
    setLoad(true);
    // Upload profile picture
    const profilePhotoUrl =
      data.photo?.[0] || data.photo
        ? await uploadImg(data.photo[0] || data.photo)
        : null;

    //Upload multiple Police Verification form img
    const policeVerificationFiles = Array.isArray(data.policeVerification)
      ? data.policeVerification
      : Array.from(data.policeVerification || []);

    const policeVerificationUrl = policeVerificationFiles.length
      ? await Promise.all(
          policeVerificationFiles.map(async (file) => {
            try {
              return await uploadImg(file);
            } catch (error) {
              console.error("Failed to upload file:", file.name, error);
              return null; // Return null or a fallback value
            }
          })
        )
      : [];

    const termFiles = Array.isArray(data.terms)
      ? data.terms
      : Array.from(data.terms || []);

    const termsUrl = termFiles.length
      ? await Promise.all(
          termFiles.map(async (file) => {
            try {
              return await uploadImg(file);
            } catch (error) {
              console.error("Failed to upload file:", file.name, error);
              return null; // Return null or a fallback value
            }
          })
        )
      : [];

    // Adhaar Front Photo
    const adhaarFrontUrl = data.aadhaarFront?.[0]
      ? await uploadImg(data.aadhaarFront[0])
      : null;
    // Upload Adhaar Back Photo
    const adhaarBackUrl = data.aadhaarBack?.[0]
      ? await uploadImg(data.aadhaarBack[0])
      : null;

    // API call or other submission logic here
    const finalData = {
      ...data,
      tenantStatus: "Check In",
      bookingId: id || "",
      photo: profilePhotoUrl,
      policeVerification: policeVerificationUrl,
      terms: termsUrl,
      aadhaarFront: adhaarFrontUrl,
      aadhaarBack: adhaarBackUrl,
      name: data.name || bookingDetails.name,
      mobile: data.mobile || bookingDetails.mobileNumber,
      email: data.email || bookingDetails.email,
      bookingAmount: data.bookingAmount || bookingDetails.bookingAmount,
      state: data.state,
      city: data.city,
      pincode: data.pincode,
      hostelName: data.hostelName || bookingDetails.hostelName._id,
      floorNo: data.floorNo || bookingDetails.floorNo,
      roomId: data.roomId || bookingDetails.roomId._id,
      bedId: data.bedId || bookingDetails.bedId._id,
    };
    console.log("Data", data);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: ` ${process.env.REACT_APP_API_URL}/check_in/create-checkin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        navigate("/checkin");
        reset();
        setLoad(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
        setLoad(false);
      });
    // } else {
    //   toast.error("Please verify AADHAAR");
    // }
    console.log("Form Data Submitted: ", data);
  };

  return (
    <div className="justify-center items-center min-h-screen bg-gray-100 p-6">
      <div className="bg-white w-full p-6 rounded-lg shadow-lg">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-primaryTextColor mb-6">
            Check in Form
          </h2>
          <button
            onClick={() => navigate("/checkin")}
            className="rounded-md text-white bg-primaryColor hover:bg-[#0741c9] hover:scale-110 px-4 py-2 font-semibold tracking-wide transition duration-300 ease-in-out"
          >
            Go Back
          </button>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-1 sm:grid-cols-2 gap-6"
        >
          {/* Name of the tenant */}
          <div>
            <label
              htmlFor="place-of-work"
              className="text-sm font-medium text-primaryTextColor"
            >
              Name *
            </label>
            <input
              type="text"
              id="name"
              placeholder="Enter Your Name"
              {...register("name", {
                required: `${id ? "" : "Name is required"}`,
              })}
              value={bookingDetails.name}
              readOnly={id ? true : false}
              className={`mt-1 p-2 border ${
                errors.name ? "border-red-500" : "border-gray-300"
              } rounded w-full ${id ? "bg-gray-100" : ""}`}
            />
            {errors.name && (
              <span className="text-red-500 text-sm">
                {errors.name.message}
              </span>
            )}
          </div>

          {/* Aadhar Number */}
          <div className="relative">
            <label
              htmlFor="aadhaar"
              className="text-sm font-medium text-primaryTextColor"
            >
              Aadhar Number *
            </label>
            <input
              type="text"
              id="aadhaar"
              placeholder="0000 0000 0000"
              maxLength={12}
              {...register("aadhaar", {
                required: "Aadhar Number is required",
                pattern: {
                  value: /^[0-9]{12}$/,
                  message: "Invalid Aadhaar Number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 12);
                if (e.target.value.length === 12) {
                  setShowSendOtpButton(true);
                  setAadhaar(e.target.value);
                } else {
                  setShowSendOtpButton(false);
                }
              }}
              className={`mt-1 p-2 border ${
                errors.aadhaar ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {showSendOtpButton && (
              <button
                type="button"
                className="px-2 py-1 text-white bg-green-500 hover:bg-green-700 rounded-md text-sm my-2 font-semibold"
                onClick={() => {
                  setOpenOTPModal(true);
                  // handleSendOTPClick(aadhaar);
                }}
              >
                Send OTP
              </button>
            )}
            {errors.aadhaar && (
              <span className="text-red-500 text-sm">
                {errors.aadhaar.message}
              </span>
            )}
          </div>

          {/* Pan Number */}
          <div>
            <label
              htmlFor="pan"
              className="text-sm font-medium text-primaryTextColor"
            >
              Pan Number
            </label>
            <input
              type="text"
              id="pan"
              maxLength={10}
              placeholder="ABCDE1234F"
              {...register("pan")}
              className={`mt-1 p-2 border border-gray-300 rounded w-full`}
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
              }}
            />
            {errors.pan && (
              <span className="text-red-500 text-sm">{errors.pan.message}</span>
            )}
          </div>

          {/* Mobile Number */}
          {id ? (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Mobile Number *
              </label>
              <input
                type="text"
                disabled
                value={bookingDetails?.mobileNumber}
                className="mt-1 block w-full border  rounded-md shadow-sm p-2 bg-gray-100"
              />
            </div>
          ) : (
            <div>
              <label
                htmlFor="mobile"
                className="text-sm font-medium text-primaryTextColor"
              >
                Mobile Number *
              </label>
              <input
                type="text"
                id="mobile"
                placeholder="Enter Mobile Number"
                {...register("mobile", {
                  required: "Mobile Number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Invalid Mobile Number",
                  },
                })}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
                className={`mt-1 p-2 border ${
                  errors.mobile ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.mobile && (
                <span className="text-red-500 text-sm">
                  {errors.mobile.message}
                </span>
              )}
            </div>
          )}

          {/* Email ID */}
          {id ? (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Email ID *
              </label>
              <input
                type="text"
                disabled
                value={bookingDetails?.email}
                className="mt-1 block w-full border  rounded-md shadow-sm p-2 bg-gray-100"
              />
            </div>
          ) : (
            <div>
              <label
                htmlFor="email"
                className="text-sm font-medium text-primaryTextColor"
              >
                Email ID *
              </label>
              <input
                type="email"
                id="email"
                placeholder="Enter Email"
                {...register("email", {
                  required: "Email ID is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid Email Address",
                  },
                })}
                className={`mt-1 p-2 border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.email && (
                <span className="text-red-500 text-sm">
                  {errors.email.message}
                </span>
              )}
            </div>
          )}

          {/* Date of Birth  */}
          <div>
            <label
              htmlFor="dateOfBirth"
              className="text-sm font-medium text-primaryTextColor"
            >
              Date of Birth *
            </label>
            <input
              type="date"
              id="dateOfBirth"
              placeholder="Enter Date of Birth"
              {...register("dateOfBirth", {
                required: "Date of Birth ID is required",
              })}
              className={`mt-1 p-2 border ${
                errors.dateOfBirth ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.dateOfBirth && (
              <span className="text-red-500 text-sm">
                {errors.dateOfBirth.message}
              </span>
            )}
          </div>

          {/* Joining Date */}
          <div>
            <label
              htmlFor="joiningDate"
              className="text-sm font-medium text-primaryTextColor"
            >
              Joining Date *
            </label>
            <input
              type="date"
              id="joiningDate"
              {...register("joiningDate", {
                required: "Joining Date is required",
              })}
              className={`mt-1 p-2 border ${
                errors.joiningDate ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
              // value={bookingDetails?.joiningDate?.slice(0, 10)}
              onBlur={(e) => {
                const value = e.target.value;

                if (value) {
                  const selectedDate = new Date(value);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);

                  if (selectedDate < today) {
                    toast.error("Joining date cannot be in the past");
                    setValue("joiningDate", "");
                    e.target.value = "";
                  }
                }
              }}
            />
            {errors.joiningDate && (
              <span className="text-red-500 text-sm">
                {errors.joiningDate.message}
              </span>
            )}
          </div>

          {/* Booking Amount */}
          {/* Email ID */}
          {id ? (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Booking Amount *
              </label>
              <input
                type="text"
                disabled
                value={bookingDetails?.bookingAmount}
                className="mt-1 block w-full border  rounded-md shadow-sm p-2 bg-gray-100"
              />
            </div>
          ) : (
            <div>
              <label
                htmlFor="bookingAmount"
                className="text-sm font-medium text-primaryTextColor"
              >
                Booking Amount *
              </label>
              <input
                type="number"
                id="bookingAmount"
                placeholder="₹"
                {...register("bookingAmount", {
                  required: "Booking Amount is required",
                  min: {
                    value: 1,
                    message: "Amount must be greater than 0",
                  },
                })}
                className={`mt-1 p-2 border ${
                  errors.bookingAmount ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.bookingAmount && (
                <span className="text-red-500 text-sm">
                  {errors.bookingAmount.message}
                </span>
              )}
            </div>
          )}

          <div>
            <label
              htmlFor="place-of-work"
              className="text-sm font-medium text-primaryTextColor"
            >
              Place of Work
            </label>
            <input
              type="text"
              id="place-of-work"
              placeholder="Enter Place of Work"
              {...register("placeOfWork", {
                required: false,
              })}
              className={`mt-1 p-2 border ${
                errors.placeOfWork ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.placeOfWork && (
              <span className="text-red-500 text-sm">
                {errors.placeOfWork.message}
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="sos-name"
              className="text-sm font-medium text-primaryTextColor"
            >
              SOS Person Name *
            </label>
            <input
              type="text"
              id="sos-name"
              placeholder="Enter SOS Person Name"
              {...register("sosPersonName", {
                required: "SOS Person Name is required",
              })}
              className={`mt-1 p-2 border ${
                errors.sosPersonName ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.sosPersonName && (
              <span className="text-red-500 text-sm">
                {errors.sosPersonName.message}
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="relation-sos"
              className="text-sm font-medium text-primaryTextColor"
            >
              Relation with SOS Person *
            </label>
            <input
              type="text"
              id="relation-sos"
              placeholder="Enter Relation"
              {...register("relationWithSOS", {
                required: "Relation with SOS Person is required",
              })}
              className={`mt-1 p-2 border ${
                errors.relationWithSOS ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.relationWithSOS && (
              <span className="text-red-500 text-sm">
                {errors.relationWithSOS.message}
              </span>
            )}
          </div>
          {/* SOS Contact Number */}
          <div>
            <label
              htmlFor="sos-contact"
              className="text-sm font-medium text-primaryTextColor"
            >
              SOS Contact Number *
            </label>
            <input
              type="text"
              id="sos-contact"
              placeholder="Enter SOS Contact Number"
              {...register("sosContact", {
                required: "SOS Contact Number is required",
                pattern: {
                  value: /^[6-9]\d{9}$/,
                  message:
                    "Invalid contact number. Must be 10 digits starting with 6-9",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
              }}
              className={`mt-1 p-2 border ${
                errors.sosContact ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.sosContact && (
              <span className="text-red-500 text-sm">
                {errors.sosContact.message}
              </span>
            )}
          </div>

          {/* Home Address */}
          <div className="sm:col-span-2">
            <label
              htmlFor="address"
              className="text-sm font-medium text-primaryTextColor"
            >
              Home Address *
            </label>
            <textarea
              id="address"
              placeholder="Enter Full Address"
              {...register("homeAddress", {
                required: "Home Address is required",
              })}
              className={`mt-1 p-2 border ${
                errors.homeAddress ? "border-red-500" : "border-gray-300"
              } rounded w-full resize-none`}
            ></textarea>
            {errors.homeAddress && (
              <span className="text-red-500 text-sm">
                {errors.homeAddress.message}
              </span>
            )}
          </div>

          {/* State */}
          <div>
            <label
              htmlFor="state"
              className="text-sm font-medium text-primaryTextColor"
            >
              State *
            </label>
            <Select
              options={allStates}
              onChange={(option) => {
                console.log("option", option);
                setSelectedState(option);
                setValue("state", option.label);
              }}
              required
              placeholder="Select State"
              className={`border ${
                errors.state ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.state && (
              <span className="text-red-500 text-sm">
                {errors.state.message}
              </span>
            )}
          </div>

          {/* City */}
          <div>
            <label
              htmlFor="city"
              className="text-sm font-medium text-primaryTextColor"
            >
              City *
            </label>

            <Select
              options={allCities}
              value={selectedCity}
              onChange={(option) => {
                console.log("option in City: ", option);
                setValue("city", option.value);
              }}
              required
              placeholder="Select your City"
              className={`border ${
                errors.city ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.city && (
              <span className="text-red-500 text-sm">
                {errors.city.message}
              </span>
            )}
          </div>

          {/* PINCODE */}
          <div>
            <label
              htmlFor="pincode"
              className="text-sm font-medium text-primaryTextColor"
            >
              PINCODE *
            </label>

            <input
              type="number"
              id="pincode"
              placeholder="Enter PINCODE"
              {...register("pincode", {
                required: "PIN Code is required",
                pattern: {
                  value: /^[1-9][0-9]{5}$/,
                  message: "Invalid PIN Code",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 6);
              }}
              className={`mt-1 p-2 border ${
                errors.pincode ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.pincode && (
              <span className="text-red-500 text-sm">
                {errors.pincode.message}
              </span>
            )}
          </div>

          {/* Reason of Stay */}
          <div>
            <label
              htmlFor="reason-stay"
              className="text-sm font-medium text-primaryTextColor"
            >
              Reason of Stay *
            </label>
            <input
              type="text"
              id="reason-stay"
              placeholder="Enter Reason of Stay"
              {...register("reasonOfStay", {
                required: "Reason of Stay is required",
              })}
              className={`mt-1 p-2 border ${
                errors.reasonOfStay ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.reasonOfStay && (
              <span className="text-red-500 text-sm">
                {errors.reasonOfStay.message}
              </span>
            )}
          </div>
          {/* Security Deposit */}
          <div>
            <label
              htmlFor="security-deposit"
              className="text-sm font-medium text-primaryTextColor"
            >
              Security Deposit *
            </label>
            <input
              type="text"
              id="security-deposit"
              placeholder="Enter Amount (₹)"
              {...register("securityDeposit", {
                required: "Security Deposit is required",
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message:
                    "Invalid amount. Enter a valid number with up to 2 decimals",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.securityDeposit ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.securityDeposit && (
              <span className="text-red-500 text-sm">
                {errors.securityDeposit.message}
              </span>
            )}
          </div>
          {/* building name */}
          {id ? (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Building Name *
              </label>
              <input
                type="text"
                disabled
                value={bookingDetails?.hostelName?.nameBuilding}
                className="mt-1 block w-full border  rounded-md shadow-sm p-2 bg-gray-100"
              />
            </div>
          ) : (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Building Name *
              </label>
              <select
                {...register("hostelName", { required: true })}
                className={`mt-1 block w-full border ${
                  errors.hostelName ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                onChange={(e) => {
                  getFloors(e.target.value);
                  setBuildingId(e.target.value);
                }}
              >
                <option value="">Select Building</option>
                {building.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.nameBuilding}
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* floor no */}
          {id ? (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Floor No *
              </label>
              <select
                disabled
                className={`mt-1 block w-full border ${
                  errors.floorNo ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2 bg-gray-200`}
              >
                <option value={bookingDetails.floorNo} selected>
                  {bookingDetails.floorNo}
                </option>
              </select>
            </div>
          ) : (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Floor No *
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.floorNo ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("floorNo", { required: true })}
                onChange={(e) => getConfiguredRoomByBuilding(e.target.value)}
              >
                <option value="">Select a floor</option>
                {floor.map((f, index) => (
                  <option key={index} value={f.floorNumber}>
                    Floor-{f.floorNumber}
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* Room No  */}
          {id ? (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Room No *
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.roomId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2 `}
              >
                <option value={bookingDetails?.roomId?.roomNumber} selected>
                  R-F{bookingDetails?.floorNo}
                  {String(bookingDetails?.roomId?.roomNumber).padStart(3, "0")}
                </option>
              </select>
            </div>
          ) : (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Room No *
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.roomNo ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("roomId", { required: true })}
                onChange={(e) => {
                  // handleBed(e.target.value);
                  getRoomById(e.target.value);
                }}
              >
                <option value="">Select Room</option>
                {rooms.map((room, index) => (
                  <option key={index} value={String(room._id)}>
                    R-F{floorNumber}
                    {String(room.roomNumber).padStart(3, "0")}
                  </option>
                ))}
              </select>
            </div>
          )}
          {id ? (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Select from available Beds *
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.bedId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
              >
                <option value={bookingDetails?.bedId?.bedNumber} selected>
                  {bookingDetails?.bedId?.bedNumber}
                </option>
              </select>
            </div>
          ) : (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Select from available Beds *
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.bedId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("bedId", { required: true })}
              >
                <option value="">Select Bed Number</option>
                {bed
                  .sort((a, b) => {
                    const numA = parseInt(a.bedNumber.slice(1)); // Extract the number after 'B'
                    const numB = parseInt(b.bedNumber.slice(1)); // Extract the number after 'B'
                    return numA - numB; // Compare the numbers
                  })
                  ?.map((bed, index) => (
                    <option
                      key={index}
                      value={bed._id}
                      disabled={bed.isOccupied}
                      style={{
                        color: bed.isOccupied ? "green" : "black",
                      }}
                    >
                      {bed.bedNumber} {bed.isOccupied && "(Occupied)"}
                    </option>
                  ))}
              </select>
            </div>
          )}

          {/* Rent of Bed */}
          <div>
            <label
              htmlFor="bed-rent"
              className="text-sm font-medium text-primaryTextColor"
            >
              Rent of Bed *
            </label>
            <input
              type="text"
              id="bed-rent"
              // value={roomData.bedRent}
              placeholder="Enter Rent"
              {...register("bedRent", {
                required: "Rent of Bed is required",
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message:
                    "Invalid rent format. Enter a valid number with up to 2 decimals",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.bedRent ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.bedRent && (
              <span className="text-red-500 text-sm">
                {errors.bedRent.message}
              </span>
            )}
          </div>
          {/* Photo */}
          <div>
            <label
              htmlFor="photo"
              className="text-sm font-medium text-primaryTextColor"
            >
              Photo
            </label>

            {/* File Input */}
            <div className="flex items-center gap-2 ">
              <input
                type={isCam ? "hidden" : "file"}
                id="photo"
                {...register("photo", {
                  // validate: {
                  //   fileSize: (files) =>
                  //     files[0]?.size <= 2 * 1024 * 1024 ||
                  //     "File size must be less than 2MB",
                  // },
                })}
                accept="image/*"
                className={`mt-1 p-2 border ${
                  errors.photo ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {isCam ? (
                <button
                  type="button"
                  onClick={() => {
                    setIsCam(false);
                    setCapturedImage("");
                  }}
                  className="bg-primaryColor hover:bg-primaryBtnHoverColor text-white px-4 py-2 rounded"
                >
                  Choose From Local
                </button>
              ) : (
                <FaCameraRetro
                  size={40}
                  onClick={openCamera}
                  className="text-primaryBtnColor cursor-pointer hover:text-primaryBtnHoverColor "
                />
              )}
            </div>

            {errors.photo && (
              <span className="text-red-500 text-sm">
                {errors.photo.message}
              </span>
            )}

            {isCameraOpen && (
              <OpenCameraComponent
                isCameraLoading={isCameraLoading}
                videoRef={videoRef}
                capturePhoto={capturePhoto}
                closeCamera={closeCamera}
              />
            )}

            {/* Captured Image Preview */}
            {capturedImage && (
              <div className="mt-4">
                <h3 className="text-sm font-medium">Captured Photo:</h3>
                <div className="flex gap-1">
                  <img
                    src={capturedImage}
                    alt="Captured"
                    className="w-32 h-auto border rounded"
                  />
                  <FaWindowClose
                    size={25}
                    onClick={() => {
                      clearCapturedImage();
                    }}
                    className="cursor-pointer"
                  />
                </div>
              </div>
            )}
          </div>

          {/* Police Verification Form */}
          <div>
            <label
              htmlFor="police-verification"
              className="text-sm font-medium text-primaryTextColor"
            >
              Police Verification Form
            </label>
            <input
              type="file"
              id="police-verification"
              accept="image/*"
              {...register("policeVerification", {
                // validate: {
                //   acceptedFormats: (files) =>
                //     files[0]?.type === "application/pdf"
                //       ? true
                //       : "Only PDF files are allowed",
                //   fileSize: (files) =>
                //     files[0]?.size <= 2 * 1024 * 1024 ||
                //     "File size must be less than 2MB",
                // },
              })}
              multiple
              className={`mt-1 p-2 border ${
                errors.policeVerification ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.policeVerification && (
              <span className="text-red-500 text-sm">
                {errors.policeVerification.message}
              </span>
            )}
          </div>

          {/* T&C Form */}
          <div>
            <label
              htmlFor="terms"
              className="text-sm font-medium text-primaryTextColor"
            >
              T&C Form
            </label>
            <input
              type="file"
              id="terms"
              accept="image/*"
              {...register("terms", {})}
              multiple
              className={`mt-1 p-2 border ${
                errors.terms ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.terms && (
              <span className="text-red-500 text-sm">
                {errors.terms.message}
              </span>
            )}
          </div>

          {/* Aadhaar Card Front Image */}
          <div>
            <label
              htmlFor="aadhaar-front"
              className="text-sm font-medium text-primaryTextColor"
            >
              Aadhaar Card Front Image *
            </label>
            <input
              type="file"
              id="aadhaar-front"
              accept="image/*"
              {...register("aadhaarFront", {
                required: "Aadhaar Card Front Image is required",
                validate: {
                  acceptedFormats: (files) =>
                    files[0]?.type === "image/jpeg" ||
                    files[0]?.type === "image/png"
                      ? true
                      : "Only JPEG or PNG formats are allowed",
                  fileSize: (files) =>
                    files[0]?.size <= 2 * 1024 * 1024 ||
                    "File size must be less than 2MB",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.aadhaarFront ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.aadhaarFront && (
              <span className="text-red-500 text-sm">
                {errors.aadhaarFront.message}
              </span>
            )}
          </div>

          {/* Aadhaar Card Back Image */}
          <div>
            <label
              htmlFor="aadhaar-back"
              className="text-sm font-medium text-primaryTextColor"
            >
              Aadhaar Card Back Image *
            </label>
            <input
              type="file"
              accept="image/*"
              id="aadhaar-back"
              {...register("aadhaarBack", {
                required: "Aadhaar Card Back Image is required",
                validate: {
                  acceptedFormats: (files) =>
                    files[0]?.type === "image/jpeg" ||
                    files[0]?.type === "image/png"
                      ? true
                      : "Only JPEG or PNG formats are allowed",
                  fileSize: (files) =>
                    files[0]?.size <= 2 * 1024 * 1024 ||
                    "File size must be less than 2MB",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.aadhaarBack ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.aadhaarBack && (
              <span className="text-red-500 text-sm">
                {errors.aadhaarBack.message}
              </span>
            )}
          </div>
          {/* Other Fields */}
          {/* Repeat similar blocks for all fields such as `placeOfWork`, `sosName`, `relationSos`, `address`, etc., ensuring they include proper validation rules. */}
          {/* Submit and Cancel Buttons */}
          <div className="flex justify-between sm:col-span-2 mt-4 gap-5">
            <button
              type="button"
              onClick={() => navigate("/checkin")}
              className="bg-gray-300 text-primaryTextColor px-4 py-2 rounded w-[50%]"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor text-white px-4 py-2 rounded w-[50%]"
            >
              {"Submit"}
            </button>
          </div>
        </form>
      </div>
      {openOTPModal && (
        <AadhaarOTPModal
          setOpenOTPModal={setOpenOTPModal}
          sendOTPResponse={sendOTPResponse}
          setLoad={setLoad}
          setIsAadhaarVerified={setIsAadhaarVerified}
        />
      )}
      {load && (
        <div className="fixed inset-0  h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
}

export default CreateCheckIn;
